export default class NewTag {
  id: number
  category?: string
  value: string
  isEditable: boolean

  constructor(json) {
    this.id = json.id
    this.category = json.category
    this.value = json.value
    this.isEditable = json.is_editable
  }
}
